import { useContext } from 'react';
import GAContext from '@/contexts/google-analytics';

const useGA = () => {
  const value = useContext(GAContext);

  return value;
};

export default useGA;